export default __webpack_public_path__ + "static/media/person4.90f17f38.png";